import {
  Legends as LegendsUI,
  TierType
} from '@com-delta-idp/mnx-capability-flyout-ui';
import { LEGEND_CLASS_NAMES } from '../../constants/status-tracker/status-tracker.constants';
import { Legends } from '../../models/status-tracker/status-tracker.interfaces';

export const getLegends = (tier: TierType, legends: Legends[]): LegendsUI => {
  return {
    tier,
    types: legends.map((legend) => {
      return {
        title: legend.title,
        className: LEGEND_CLASS_NAMES[`${legend.title}-${tier}`]
      };
    })
  };
};
